import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle escape key press to close modal
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Handle input changes and clear errors
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Comprehensive form validation
  const validateForm = () => {
    const newErrors = {};

    // First name validation
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    } else if (formData.firstName.trim().length < 2) {
      newErrors.firstName = "First name must be at least 2 characters";
    }

    // Last name validation
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    } else if (formData.lastName.trim().length < 2) {
      newErrors.lastName = "Last name must be at least 2 characters";
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email address is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Phone validation
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\+?[\d\s\-\(\)]{10,}$/.test(formData.phone)) {
      newErrors.phone = "Please enter a valid phone number (minimum 10 digits)";
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      // Show error notification with SweetAlert2
    
      return;
    }

    const payload = {
      ...formData,
      name: `${formData.firstName} ${formData.lastName}`,
      ipaddress: "",
      number: formData.phone,
      pageUrl: window.location.href,
    };

    try {
      setIsSubmitting(true);

      const response = await fetch(
        "https://stagging-server786.com/send-mail/webinventix-ai/sendmail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        // Reset form
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
        });
        setErrors({});

        // Show success message with SweetAlert2
        // await Swal.fire({
        //   title: 'Success!',
        //   text: 'Your request has been submitted successfully! Our specialist will contact you soon.',
        //   icon: 'success',
        //   confirmButtonColor: '#28a745',
        //   confirmButtonText: 'Continue',
        //   background: '#fff',
        //   color: '#333',
        //   timer: 3000,
        //   timerProgressBar: true,
        //   showClass: {
        //     popup: 'animate__animated animate__zoomIn'
        //   },
        //   hideClass: {
        //     popup: 'animate__animated animate__zoomOut'
        //   }
        // });

        onClose();

        // Navigate to thank you page
        // setTimeout(() => {
        //   window.location.href = "/professional-website-development/thankyou";
        // }, 500);
        navigate("/professional-website-development/thankyou");
      } else {
        throw new Error("Network response was not ok");
      }
    } catch (err) {
      console.error("Form submission error:", err);

      // Show error message with SweetAlert2
      Swal.fire({
        title: "Submission Failed!",
        text: "Something went wrong while submitting your request. Please try again or contact us directly.",
        icon: "error",
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Try Again",
        showCancelButton: true,
        cancelButtonText: "Contact Support",
        cancelButtonColor: "#6c757d",
        background: "#fff",
        color: "#333",
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          // User clicked "Contact Support" - you can add phone number or email here
          window.location.href = "tel:+16467607313";
        }
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle backdrop click to close modal
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <style jsx>{`
        .baba-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
          animation: fadeIn 0.3s ease-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideIn {
          from {
            transform: translateY(-50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .baba-modal {
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
          max-width: 600px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
          animation: slideIn 0.3s ease-out;
        }

        .baba-close-btn {
          position: absolute;
          top: 15px;
          right: 20px;
          font-size: 28px;
          font-weight: bold;
          color: #aaa;
          cursor: pointer;
          z-index: 1001;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: all 0.3s ease;
        }

        .baba-close-btn:hover {
          color: #000;
          background-color: #f8f9fa;
        }

        .modal-content {
          padding: 0;
        }

        .popupform {
          padding: 40px;
        }

        .popupform h2 {
          color: #333;
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 15px;
          text-align: center;
          line-height: 1.3;
        }

        .popupform p {
          color: #666;
          font-size: 1rem;
          text-align: center;
          margin-bottom: 30px;
          line-height: 1.5;
        }

        .popupform form ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .popupform form li {
          margin-bottom: 25px;
        }

        .form-input {
          width: 100%;
          padding: 15px 18px;
          border: 2px solid #e1e5e9;
          border-radius: 10px;
          font-size: 14px;
          font-family: inherit;
          transition: all 0.3s ease;
          background-color: #fff;
          box-sizing: border-box;
        }

        .form-input:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
        }

        .form-input.error {
          border-color: #dc3545;
          background-color: #fff5f5;
        }

        .form-input.error:focus {
          border-color: #dc3545;
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
        }

        .form-textarea {
          min-height: 120px;
          resize: vertical;
          font-family: inherit;
        }

        .error-message {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 500;
        }

        .error-icon {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }

        .submit-btn {
          width: 100%;
          background: linear-gradient(135deg, #007bff, #0056b3);
          border: none;
          padding: 16px 24px;
          font-size: 1.5rem;
          font-weight: 600;
          color: #fff;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          position: relative;
          overflow: hidden;
        }

        .submit-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, #0056b3, #004085);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.3);
        }

        .submit-btn:disabled {
          background: #6c757d;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .loading-spinner {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 2px solid #fff;
          border-radius: 50%;
          border-top-color: transparent;
          animation: spin 1s linear infinite;
          margin-right: 10px;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        /* SweetAlert2 Custom Styling */
        .swal2-popup {
          border-radius: 15px !important;
          padding: 2rem !important;
        }

        .swal2-title {
          font-size: 1.5rem !important;
          font-weight: 600 !important;
        }

        .swal2-content {
          font-size: 1rem !important;
          line-height: 1.5 !important;
        }

        .swal2-confirm {
          border-radius: 8px !important;
          padding: 12px 24px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }

        .swal2-cancel {
          border-radius: 8px !important;
          padding: 12px 24px !important;
          font-weight: 600 !important;
        }

        /* Row layout for name fields */
        .name-row {
          display: flex;
          gap: 15px;
        }

        .name-row .form-group {
          flex: 1;
        }

        /* Responsive design */
        @media (max-width: 768px) {
          .baba-modal {
            margin: 10px;
            border-radius: 15px;
          }

          .popupform {
            padding: 30px 25px;
          }

          .popupform h2 {
            font-size: 1.5rem;
          }

          .name-row {
            flex-direction: column;
            gap: 0;
          }

          .baba-close-btn {
            top: 10px;
            right: 15px;
            font-size: 24px;
          }
        }

        @media (max-width: 480px) {
          .baba-modal-overlay {
            padding: 10px;
          }

          .popupform {
            padding: 25px 20px;
          }

          .form-input {
            padding: 12px 15px;
          }
        }
      `}</style>

      <div className="baba-modal-overlay" onClick={handleBackdropClick}>
        <div className="baba-modal">
          <span className="baba-close-btn" onClick={onClose}>
            &times;
          </span>
          <div className="modal-content">
            <div className="popupform">
              <h2>Submit Your Details & Our Specialist will Call You</h2>
              <p>
                Web Inventix is ready to help your business. Fill out the form
                to talk to our design consultant.
              </p>

              <div onSubmit={handleSubmit}>
                <ul>
                  {/* Name fields in a row */}
                  <li>
                    <div className="name-row">
                      <div className="form-group">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="First Name *"
                          value={formData.firstName}
                          onChange={handleChange}
                          className={`form-input ${
                            errors.firstName ? "error" : ""
                          }`}
                          required
                        />
                        {errors.firstName && (
                          <div className="error-message">
                            <svg
                              className="error-icon"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clipRule="evenodd"
                              />
                            </svg>
                            {errors.firstName}
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Last Name *"
                          value={formData.lastName}
                          onChange={handleChange}
                          className={`form-input ${
                            errors.lastName ? "error" : ""
                          }`}
                          required
                        />
                        {errors.lastName && (
                          <div className="error-message">
                            <svg
                              className="error-icon"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clipRule="evenodd"
                              />
                            </svg>
                            {errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>
                  </li>

                  {/* Email field */}
                  <li>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address *"
                      value={formData.email}
                      onChange={handleChange}
                      className={`form-input ${errors.email ? "error" : ""}`}
                      required
                    />
                    {errors.email && (
                      <div className="error-message">
                        <svg
                          className="error-icon"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {errors.email}
                      </div>
                    )}
                  </li>

                  {/* Phone field */}
                  <li>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number *"
                      value={formData.phone}
                      onChange={handleChange}
                      className={`form-input ${errors.phone ? "error" : ""}`}
                      required
                    />
                    {errors.phone && (
                      <div className="error-message">
                        <svg
                          className="error-icon"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {errors.phone}
                      </div>
                    )}
                  </li>

                  {/* Message field */}
                  <li>
                    <textarea
                      name="message"
                      placeholder="Project Description *"
                      value={formData.message}
                      onChange={handleChange}
                      style={{resize: "none"}}
                      className={`form-input form-textarea ${
                        errors.message ? "error" : ""
                      }`}
                    />
                  </li>

                  {/* Submit button */}
                  <li>
                    <button
                      className="submit-btn"
                      type="button"
                      disabled={isSubmitting}
                      onClick={handleSubmit}
                    >
                      {isSubmitting && (
                        <span className="loading-spinner"></span>
                      )}
                      {isSubmitting ? "Submitting..." : "Submit Request"}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactModal;
